// removed by extract-text-webpack-plugin
module.exports = {"BreakpointFromMedium":"(min-width: 640px)","carouselContainer":"G7d8b47","CTAContainer":"Gd13d1d"};